export default "__VITE_ASSET__CmZTGowg__"